// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1Xkx7","col":"Table_col__3Fv2I","fulfillmentStatus":"Table_fulfillmentStatus__UQL9H","emailCol":"Table_emailCol__2vFTK"};